import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-solid';

class Navigation extends Component {
  render() {
    return (
      <div>
        <div className="uk-visible@m">
          <nav className="uk-navbar-container uk-margin uk-box-shadow-small bg-nav">
            <div className="uk-container uk-container-expand">
              <div className="uk-navbar">
                <div className="uk-navbar-left">
                  <NavLink to="/" className="uk-margin-large-left uk-text-uppercase uk-navbar-item uk-logo uk-text-bold">Sajid</NavLink>
                </div>
                <div className="uk-navbar-right">
                  <ul className="uk-navbar-nav uk-margin-large-right">
                    <li><NavLink activeClassName="selected" to="/" exact={true}><FontAwesomeIcon icon="home"/><span>&nbsp;</span>Home</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/about"><FontAwesomeIcon icon="user"/><span>&nbsp;</span>About</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/skills"><FontAwesomeIcon icon="code"/><span>&nbsp;</span>Skills</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/experience"><FontAwesomeIcon icon="lightbulb"/><span>&nbsp;</span>Experience</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/education"><FontAwesomeIcon icon="graduation-cap"/><span>&nbsp;</span>Education</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/work"><FontAwesomeIcon icon="code-branch"/><span>&nbsp;</span>Work</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/contact"><FontAwesomeIcon icon="envelope"/><span>&nbsp;</span>Contact</NavLink></li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div className="uk-hidden@m">
          <nav className="uk-navbar uk-navbar-container uk-margin bg-nav">
            <div className="uk-navbar-left">
              <NavLink activeClassName="selected" to="/" className="uk-text-uppercase uk-navbar-item uk-logo uk-text-bold">Sajid</NavLink>
            </div>
            <div className="uk-navbar-right">
              <div className="uk-inline">
                <a className="uk-button uk-button-default uk-navbar-toggle" type="button" uk-navbar-toggle-icon="true"><FontAwesomeIcon icon="bars" className="fa-2x"/></a>
                <div uk-dropdown="mode: click,boundary: .boundary">
                  <ul className="uk-nav uk-dropdown-nav">
                    <li><NavLink activeClassName="selected" to="/"><FontAwesomeIcon icon="home"/><span>&nbsp;</span>Home</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/about"><FontAwesomeIcon icon="user"/><span>&nbsp;</span>About</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/skills"><FontAwesomeIcon icon="code"/><span>&nbsp;</span>Skills</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/experience"><FontAwesomeIcon icon="lightbulb"/><span>&nbsp;</span>Experience</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/education"><FontAwesomeIcon icon="graduation-cap"/><span>&nbsp;</span>Education</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/work"><FontAwesomeIcon icon="code-branch"/><span>&nbsp;</span>Work</NavLink></li>
                    <li><NavLink activeClassName="selected" to="/contact"><FontAwesomeIcon icon="envelope"/><span>&nbsp;</span>Contact</NavLink></li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    )
  }
}


export default Navigation;





// WEBPACK FOOTER //
// src/components/Navigation.js